/* eslint-disable require-await */
import React, { useMemo, useState, useRef } from 'react';
import { GanttChartGrid } from '@components';
import { getGanttGridColumns } from '@model/sectionWidget.model';
import { WIDGET_GANTT_CHART_STATUS } from '@utils/enums';
import actions from '@flux/action';
import { useDispatch } from 'react-redux';
import useTheme from '@hooks/useTheme';

export default function GanttGrid({
  editTableRef,
  isEditMode,
  sourceData,
  handleSave,
  toggleEdit,
  afterCancel,
  link,
}) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const [isNotesHide, setIsNotesHide] = useState(
    sourceData.length !== 0 && sourceData[0].isnoteshide,
  );
  const isNotesHideOrigin = useRef(
    sourceData.length !== 0 && sourceData[0].isnoteshide,
  );
  // const sourceDataRef = useRef(sourceData);
  const [edittingTableDataSource, setEdittingTableDataSource] =
    useState(sourceData);
  const dispatch = useDispatch();

  const ganttHandleSave = (data) => {
    dispatch(actions.changeWidget({ widgetId: link, data: {} }));
    handleSave(data);
  };

  const editTableParams = useMemo(
    () => ({
      isEditMode,
      edittingTableDataSource,
      setEdittingTableDataSource,
      tableProps: {
        pagination: false,
        rowKey: 'id',
      },
      tableColumns: getGanttGridColumns(
        sourceData,
        edittingTableDataSource,
        isEditMode,
        isNotesHide,
        setIsNotesHide,
        isLightMode,
      ),
      defaultDataSource: sourceData.map((item) => ({
        ...item,
        status: item.status || 'Not Started',
      })),
      // dataChange: onDataChange,
      saveData: ganttHandleSave,
      toggleEdit,
      beforeEditRowFunc: (newItem) => {
        if (newItem.type === WIDGET_GANTT_CHART_STATUS.MILESTONE) {
          newItem.endDate = newItem.startDate;
          newItem.l2 = '';
        }
      },
      changeCustmizeData: (newArr) => {
        newArr.map((d) => {
          d.isnoteshide = isNotesHide;
        });
      },
      afterCancel: () => {
        sourceData.map((data) => {
          data.isnoteshide = isNotesHideOrigin.current;
        });
        setIsNotesHide(isNotesHideOrigin.current);
        if (typeof afterCancel === 'function') {
          afterCancel();
        }
      },
    }),
    [isEditMode, isNotesHide, sourceData, edittingTableDataSource],
  );

  return <GanttChartGrid ref={editTableRef} {...editTableParams} />;
}
